import { Loader2 } from 'lucide-react';
import { cn } from '@/lib/utils';

export type SpinnerProps = {
  size?: 'sm' | 'md' | 'lg';
  /** Accessible text; without it the spinner is decorative. */
  label?: string;
  className?: string;
};

const SIZES = { sm: 'h-3.5 w-3.5', md: 'h-4 w-4', lg: 'h-6 w-6' } as const;

/** The one loading spinner (inherits the text colour). */
export function Spinner({ size = 'md', label, className }: SpinnerProps) {
  return (
    <Loader2
      className={cn('shrink-0 animate-spin', SIZES[size], className)}
      role={label ? 'status' : undefined}
      aria-label={label}
      aria-hidden={label ? undefined : true}
    />
  );
}
